/**
 * description:
 * author: 1580043700@qq.com
 * create_date: 2023/10/25-11:12
 */

interface ConfigProps {
  api: string
  svi: string
  svi2: string
}

const getAppGateWay = () => process.env.GATE_WAY
const getSaasUrl = () => process.env.SAAS_ENV
const getSmallProgramUrl = () => process.env.SMALL_PROGRAM_ENV
export const sviPrefix = 'svi/api'

const config: ConfigProps = {
  api: getAppGateWay() || '',
  svi: getAppGateWay() + sviPrefix,
  svi2: getSaasUrl() + sviPrefix,
  smallProgramUrl: getSmallProgramUrl(),
}

export default config
